

const popperInitializer = () => {
  $('[data-toggle="popover"]').popover();
}

export {
  popperInitializer
}